import React from 'react'
import PropTypes from 'prop-types'
import {customIcon} from '../shared/styles'

const InactiveUserIcon = ({size}) => {
    const {container, content} = customIcon(size, '#E6E6E6', '#666666')
    return (
        <div style={container}>
            <i data-testid="mi" className="material-icons" style={content}>
                block
            </i>
        </div>
    )
}

InactiveUserIcon.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']).isRequired
}
export default InactiveUserIcon
